import { Input, InputProps } from '@/shadcn_components/ui/input';
import { useState } from 'react';
import { Table } from '@tanstack/react-table';
import { Search } from 'lucide-react';
import { cn } from '@/lib/tailwind-utils';

export type LiveSearchFilterProps<TData = any> = {
  table: Table<TData>;
  source: string;
  label?: string;
} & Omit<InputProps, 'source' | 'ref'>;

export const LiveSearchFilter = <TData,>(props: LiveSearchFilterProps<TData>) => {
  const { table, source, label, className, ...remainProps } = props;
  const [value, setValue] = useState('');

  function onChangeInput(e) {
    const newValue = e.target.value;
    setValue(newValue);
    table.setGlobalFilter(newValue);
  }

  return (
    <div className="w-full relative flex items-center p-0">
      <Search className="absolute left-2 top-0 h-full w-4 text-muted-foreground" />
      <Input
        type="search"
        placeholder={label || 'Tìm kiếm ...'}
        className={cn('h-8 w-[150px] lg:w-[250px] pl-8', className)}
        value={value}
        onChange={onChangeInput}
        {...remainProps}
      />
    </div>
  );
};
